import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import { useContext, useEffect, useState } from 'react'
import { ParentContext } from '../../../global/cnr/contexts/ParentContext'
import { UiItemContext } from '../../../global/cnr/contexts/UiItemContext'
import ConfirmationQuestion from '../../../global/components/alerts/ConfirmationQuestion'
import NoData from '../../../global/components/alerts/NoData'
import UiSaveButtons from '../../../global/components/buttons/UiSaveButtons'
import AppForm from '../../../global/components/forms/appForms/AppForm'
import { allPageTypes } from '../../../global/enums/allPageTypes'
import { appFormTypes } from '../../../global/enums/appFormTypes'
import { gEnums } from '../../../global/enums/globalEnums'
import FullPageWrapper from '../../../global/wrappers/FullPageWrapper'
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper'
import { JitsiLive } from './JitsiLive'

export const jitsiTypes = {
  normal: 'normal',
  noRecips: 'noRecips'
}

const VideoConference = (props) => {

  let propIgnores = ['recipients']

  const { forProfileItem } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states, handlers, fns, settings } = parentContext ?? {}
  const { currentSettings_state, paps_state, videoConference_state } = states ?? {}
  const { videoConference_handlers } = handlers ?? {}
  const { appUser_fns } = fns ?? {}
  const { homeSettings } = settings ?? {}

  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appVideoConferencing } = aps_global ?? {}
  const { videoConferenceType, videoConferencingAuthLevel, videoConferencingManagers } = appVideoConferencing ?? {}

  // authContext  
  const appUserAccess = useAppUserAccess()

  // papsContext 
  const { view, viewKey } = paps_state ?? {}

  // pageContext  
  const { global: global_home } = homeSettings ?? {}
  const { videoConferencing: videoConferencing_home } = global_home ?? {}
  const { allowJitsi } = videoConferencing_home ?? {}

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_handlers, item_state } = uiItemContext ?? {}
  const { viewItem, vld_item } = item_state ?? {}
  const { pageItemActions } = viewItem ?? {}
  const { videoConferencing } = pageItemActions ?? {}

  // eslint-disable-next-line 
  const firstDataItem = vld_item ? vld_item[Object.keys(vld_item)[0]] : {}
  const { name, firstName, lastName } = firstDataItem ?? {}
  const _name = firstName && lastName ? firstName + ' ' + lastName : name;

  const _roomName = view + '-' + viewKey

  const { videoConference, data_current, meetingRooms, isReady } = videoConference_state ?? {}

  const [allowInit, setAllowInit] = useState()
  const [confirmRecips, setConfirmRecips] = useState()

  const { meetingAuthId } = videoConference ?? {}

  const meetingRoom = meetingRooms ? meetingRooms[_roomName] : null
  const { meetingInProgress } = meetingRoom ?? {}

  // eslint-disable-next-line
  const meetingStarter = (meetingAuthId === appUserAccess.uid) ? true : false

  useEffect(() => {
    const allow = appUser_fns.validateAccess_item(videoConferencingAuthLevel)
    setAllowInit(allow)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  useEffect(() => {
    let _data;
    switch (view) {
      case allPageTypes.appProfile:
        _data = {
          id: appUserAccess.uid,
          displayName: appUserAccess.displayName,
          subject: 'Personal Room',
          meetingInProgress: false,
          meetingAuthId: appUserAccess.uid,
          roomName: _roomName,
        }
        break;
      default:
        _data = {
          id: firstDataItem.id,
          displayName: appUserAccess.displayName,
          subject: firstDataItem.name,
          meetingInProgress,
          meetingAuthId: firstDataItem.meetingAuthId,
          roomName: _roomName,
        }
    }
    videoConference_handlers.handleInitVc(videoConferenceType, _data, appUserAccess, view, viewKey)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  // local
  const { recipients } = data_current ?? {}

  /** Response to the confirmation of sending a confirmation notification to the recipients */
  const handleRecipsConfirmed = () => {
    setConfirmRecips(false)
    handleStartMeeting({ notifyRecips: true })
  }

  /** Response to the cancelation of sending a confirmation notification to the recipients */
  const handleRecipsCancelled = () => {
    setConfirmRecips(false)
    handleStartMeeting({ notifyRecips: false })
  }

  const handleNoMeeting = () => {
    setConfirmRecips(false)
    item_handlers && item_handlers.handleShow_itemSidebar()
  }

  const startMeeting = (notifyStatus) => videoConference_handlers.handleStartVc(recipients, notifyStatus)

  const handleStartMeeting = (notifyStatus) => startMeeting(notifyStatus)
  const handleJoinMeeting = (notifyStatus) => videoConference_handlers.handleCancelVc()
  const handleCancelMeeting = () => videoConference_handlers.handleCancelVc()

  const form = () => <div className='jitsi-wrapper'>
    <AppForm
      appFormType={appFormTypes.jitsi}
      handleUpdateParentData={videoConference_handlers.handleUpdateCurrentData}
      data_parent={data_current}
      propIgnores={propIgnores}
    />
  </div>

  const footerStart = () => <UiSaveButtons
    delete={meetingInProgress && { oc: handleCancelMeeting, caption: 'End Meeting' }}
    save={!meetingInProgress && { oc: handleStartMeeting, caption: 'Start', icon: 'arrow right', disabled: !isReady }}
  />

  const footerJoin = () => <UiSaveButtons
    delete={meetingInProgress && { oc: handleCancelMeeting, caption: 'Leave Meeting' }}
    save={!meetingInProgress && { caption: 'Join', icon: 'arrow right', oc: handleJoinMeeting, disabled: !meetingInProgress }}
  />

  const confirm = () => {
    const cqProps = {
      header: 'Confirmation',
      question: 'Send notification to Recipients?',
      handleNo: handleRecipsCancelled,
      handleYes: handleRecipsConfirmed
    }
    return <ConfirmationQuestion  {...cqProps} />
  }

  // eslint-disable-next-line
  const confirmInProgress = () => {
    const cqProps = {
      header: 'Meeting in Progress',
      question: 'This meeting is already in progress. Would you like to join?',
      handleNo: handleNoMeeting,
      handleYes: handleJoinMeeting
    }
    return <ConfirmationQuestion  {...cqProps} />
  }

  const vcContent = () => {
    switch (videoConferenceType) {
      case gEnums.videoConferenceTypes.jitsi:
        return <JitsiLive />
      // case gEnums.videoConferenceTypes.zoom:
      //   return <ZoomMeeting />
      default:
        break;
    }
  }

  const meetingWrapper = () => <Wrapper
    content={meetingInProgress ? vcContent() : form()}
    footer={allowInit ? footerStart() : footerJoin()}
    wrapperType={meetingInProgress ? wrapperTypes.paddedFooter : wrapperTypes.padded}
    css={{ container: 'ct-jitsy' }}
  />

  const content = () => {
    if (confirmRecips) {
      return confirm()
    } else {
      return meetingWrapper()
    }
  }

  const fullPageWrapper = () => <FullPageWrapper
    content={content()}
    handleCancel={item_handlers && item_handlers.handleShow_itemSidebar}
    topperCaption={'Video Conference'}
    topperCaption2={_name}
  />


  if (!allowJitsi) { return <NoData altCaption={'Jitsi meetings are not enabled.'}></NoData> }

  if (data_current) {
    if (forProfileItem) {
      return content()
    } else {
      return fullPageWrapper()
    }
  }

  return <div></div>

}

export default VideoConference